<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.profile_history')}}</h3>
            <div class="card-toolbar">
              <b-button size="sm"><i class="fas fa-list mr-2"></i> Listele</b-button>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.items"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "ProfileHistory",
  components: {DataTable},
  data() {
    return {
      form : {
      },
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          {
            'Tarih': '22.11.2020',
            'Soru': "İl:",
            'Cevap': "Ankara",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "Cinsiyetiniz:",
            'Cevap': "Erkek",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "Doğum Tarihiniz:",
            'Cevap': "1985-06-11",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "İletişim Adresi Tercihiniz:",
            'Cevap': "Ev Adresim",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "Medeni Durumunuz:",
            'Cevap': "Evli",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "Çocuğunuz var  mı?",
            'Cevap': "Var",
            'Tür' : 'INS'
          },{
            'Tarih': '22.11.2020',
            'Soru': "Kaç Çocuğunuz Var ?",
            'Cevap': "1",
            'Tür' : 'INS'
          },
        ],
      },
    }
  },
};
</script>
